import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react'

import ViewMissions from 'views/Missions';
import ViewSingleMission from 'views/SingleMission';

import './index.scss';

function Page404() {
  return <p>Sorry, the page you are looking for does not exist</p>;
}

export default function App() {
  const { user } = useAuth0()
  const userRoles = (user && user['heuritech.roles']) || []
  const isAdmin = userRoles.includes('heuritech')

  return (
    <Switch>
      {isAdmin && <Route exact path="/missions" component={ViewMissions} />}

      <Route path="/missions/:missionId" component={ViewSingleMission} />

      <Route path="/" component={Page404} />
    </Switch>
  );
}
